<ion-app>
  <ion-split-pane contentId="main-content" [disabled]="!g.menuReady || isLoginPage()">
    <!-- Sidebar -->
    <ion-menu *ngIf="g.menuReady && !isLoginPage()" menuId="main-menu" contentId="main-content" type="overlay" class="menu-main-css">
      <ion-content>
        <app-sidebar></app-sidebar>
      </ion-content>
    </ion-menu>

    <!-- Main Content -->
    <div id="main-content" class="ion-page">
      <main class="flex-1 py-3 px-5 bg-primaryBg h-full overflow-y-auto">
        <router-outlet></router-outlet>
      </main>
    </div>
  </ion-split-pane>
</ion-app>